import { useHistory } from "react-router";
import NotificationError from "../../../../helpers/errors_notifications/NotificationError";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userCoinBalance } from "../../../../actions/user";
import { getUsersCards } from "../../../../services/userServices";
import { convertNumbers2English, showPrice } from "../../../../utils/priceFunc";
import Num2persian from "num2persian";
import { errorMessage, successMessage } from "../../../../utils/messages";
import {
  hiddenLoadingPage,
  showLoadingPage,
} from "../../../../actions/loadingPage";
import { LoadingPage } from "../../../LoadingPage/LoadingPage";
//Styles and Icons
import styles from "./DecreaseBalance.module.scss";
import ArrowBackIcon from "../../../../styles/icon/arrow_back_fill.svg";
import ArrowIcon from "../../../../styles/icon/arrowdown.svg";
import { userBankRialWithdraw } from "../../../../services/adminServices";

export default function DecreaseUserBalance() {
  const loadingBar = useSelector((state) => state.loadingBar.loading);
  const UserIRT = useSelector((state) => state.fullUserInfo.coinBalance);
  const dispatch = useDispatch();
  const history = useHistory();
  //List of user cards
  const [cards, setCards] = useState([]);
  const [cardsList, openCardsList] = useState("");
  const [deactivatedButton, setDeactivatedButton] = useState(false);
  //
  //GET USER DATA
  useEffect(() => {
    dispatch(userCoinBalance("irt"));
    const getUserCards = async () => {
      try {
        dispatch(showLoadingPage());
        const data = await getUsersCards();
        setCards(data.data.cards);
      } catch (ex) {
      } finally {
        dispatch(hiddenLoadingPage());
      }
    };
    getUserCards();
  }, []);
  //End GET User DATA

  //Details for withdraw
  const [userIban, setUserIban] = useState("");
  const [amount, setAmount] = useState("");
  const [currentAccount, setCurrentAccount] = useState("");
  useEffect(() => {
    if (userIban) {
      const filtered = cards.filter((c) => c.ibanNumber === userIban);
      setCurrentAccount(filtered[0].id);
    }
  }, [userIban]);
  const handleDecreaseBalance = async (e) => {
    e.preventDefault();
    let maximumUserBalance = UserIRT?.asset?.balance - UserIRT?.asset?.locked;
    if (!userIban) return errorMessage("شماره شبا را وارد کنید");
    if (amount > maximumUserBalance)
      return errorMessage("موجودی حساب شما کافی نمی باشد");
    if (amount < 300000)
      return errorMessage("حداقل مقدار برداشت رعایت نشده است");
    try {
      setDeactivatedButton(true);
      const body = { amount, currentAccount };
      const { data } = await userBankRialWithdraw(body);
      if (data) {
        if (!data.error) {
          dispatch(userCoinBalance("irt"));
          setAmount("");
          setUserIban("");
          successMessage(data.message);
        } else if (data.error) {
          errorMessage(data.message);
        }
      }
    } catch (ex) {
    } finally {
      setDeactivatedButton(false);
    }
  };

  //Function Handle Balance
  const handleMaximumBalance = (amount) => {
    let maximumUserBalance = UserIRT?.asset?.balance - UserIRT?.asset?.locked;
    if (maximumUserBalance < 0) {
      setAmount(0);
    } else {
      setAmount(amount.toString());
    }
  };
  return (
    <>
      {loadingBar && <LoadingPage />}
      <div className={styles.container}>
        <div className={styles.back_btn}>
          <img
            src={ArrowBackIcon}
            alt="BACK"
            width={15}
            height={15}
            onClick={() => history.goBack()}
            className="convertPicToWhite"
          />
        </div>
        <div className={`font_color_white ${styles.page_title}`}>
          برداشت از اعتبار
        </div>
        <div className={`font_color_white ${styles.container_user_balance}`}>
          <div className={styles.head_of_table_titles}>
            <div className={`font_color_white ${styles.head_title}`}>
              قابل برداشت
            </div>
            <div className={`font_color_white ${styles.head_title}`}>
              قفل شده
            </div>
            <div className={`font_color_white ${styles.head_title}`}>
              موجودی کل
            </div>
          </div>
          <div className={styles.user_moneys}>
            <div className={styles.all_balance}>
              <div className={styles.forMoneysGrid}>
                <div>تومان</div>
                <div>
                  {UserIRT?.asset?.balance &&
                    showPrice(UserIRT.asset.balance - UserIRT.asset.locked)}
                </div>
              </div>
            </div>
            <div className={styles.lock_balance}>
              <div className={styles.forMoneysGrid}>
                <div>تومان</div>
                <div>{showPrice(UserIRT?.asset?.locked)}</div>
              </div>
            </div>
            <div className={styles.removable_balance}>
              <div className={styles.forMoneysGrid}>
                <div>تومان</div>
                <div>{showPrice(UserIRT?.asset?.balance)}</div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.inputs_container}>
          <form onSubmit={handleDecreaseBalance}>
            <div className={styles.withdraw_amount_input}>
              <input
                className="changeBackgroundToWhite changeFontColorToBlack"
                id="paymentAmount"
                type="number"
                placeholder="مبلغ برداشت(تومان)"
                onChange={(e) =>
                  setAmount(convertNumbers2English(e.target.value))
                }
                value={amount}
              />
              <div
                className={styles.all_balance_btn}
                onClick={() =>
                  handleMaximumBalance(
                    UserIRT.asset.balance - UserIRT.asset.locked
                  )
                }
              >
                کل موجودی
              </div>
            </div>
            <div className={styles.persian_price}>
              {amount ? Num2persian(amount) + " تومان" : ""}
            </div>
            <div className={styles.shaba_number_container}>
              <div className={styles.choice_shaba_title}>
                شماره شبایی که قصد واریز به آن را دارید را انتخاب کنید:
              </div>
              <div className={styles.cards_pick_container}>
                <label htmlFor="checkbox-online-increase">
                  <input
                    type="checkbox"
                    className={`${styles.checkBox}`}
                    id="checkbox-online-increase"
                    onChange={(e) => openCardsList(e.target.checked)}
                    value={cardsList}
                  />
                  <div
                    className={`changeBackgroundToWhite changeFontColorToBlack ${styles.label}`}
                  >
                    <div>انتخاب شماره شبا</div>
                    <div>
                      <img
                        src={ArrowIcon}
                        alt=""
                        width={14}
                        height={14}
                        className="convertPicToGreen"
                      />
                    </div>
                  </div>
                </label>
                <ul
                  className={`${styles.ul_cards} ${
                    cardsList ? styles.openThis : ""
                  }`}
                >
                  {cards &&
                    cards?.map((card) => (
                      <li key={card.cardNumber}>
                        <label>
                          <div
                            className={`changeBackgroundToWhite changeFontColorToBlack ${styles.for_grid}`}
                          >
                            <input
                              type="radio"
                              style={{ display: "none" }}
                              name="iBanChoice"
                              value={card.ibanNumber}
                              className={styles.radioCardChoice}
                              checked={userIban === card.ibanNumber}
                              onChange={(e) => setUserIban(e.target.value)}
                            />
                            <div className={styles.checkBox2}></div>
                            <div
                              className={`changeFontColorToBlack ${styles.cardNum}`}
                            >
                              {card.ibanNumber}
                            </div>
                          </div>
                        </label>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
            <div className={styles.notificationForDecrease}>
              <NotificationError
                bgBorder="rgba(246, 85, 85, 1)"
                bgColor="rgba(246, 85, 85, 0.16)"
                fontColor="rgba(246, 85, 85, 1)"
                text="حداقل مبلغ برداشت 300000 تومان می باشد."
              />
            </div>
            <div className={styles.btn_for_submit}>
              <button type="submit" disabled={deactivatedButton}>
                ثبت درخواست
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
